import { SmartBannerEntity } from '@main/smart-banner/const';
import { StateUtils } from '@spartacus/core';

export const SMART_BANNER_FEATURE = 'smart-banner';
export const SMART_BANNER_ENTITY = '[Smart-banner] Smart-banner Entity';

export interface StateWithSmartBanner {
  [SMART_BANNER_FEATURE]: SmartBannerState;
}

export interface SmartBannerState {
  smartBanner: StateUtils.LoaderState<SmartBannerEntity>;
}
